export const ALL_EXPENSE_TYPE_REQUEST = "ALL_EXPENSE_TYPE_REQUEST"
export const ALL_EXPENSE_TYPE_SUCCESS = "ALL_EXPENSE_TYPE_SUCCESS"
export const ALL_EXPENSE_TYPE_FAIL = "ALL_EXPENSE_TYPE_FAIL"
export const CLEAR_ERRORS = "CLEAR_ERRORS"